import { all, put, takeLatest } from 'redux-saga/effects';
import {
  getDashboardFulfilled,
  getDashboardRejected,
  getDashboardRequest,
  getDashboardPartnerFulfilled,
  getDashboardPartnerRejected,
  getDashboardPartnerRequest,
  getPartnerDataGraphFulfilled,
  getPartnerDataGraphRejected,
  getPartnerDataGraphRequest,
  getDataDashboardHistoryFulfilled,
  getDataDashboardHistoryRejected,
  getDataDashboardHistoryRequest,
  getPartnerEnvironmentsCostGraphFulfilled,
  getPartnerEnvironmentsCostGraphRejected,
  getPartnerEnvironmentsCostGraphRequest,
} from './actions';
import endpoints, { api } from './endpoints';

function* getDashboardRequestSaga({ payload }) {
  const { companyUuid } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getDataDashboardCompany(companyUuid),
      data: payload,
    });
    return yield all([put(getDashboardFulfilled(data))]);
  } catch (error) {
    return yield put(getDashboardRejected());
  }
}

function* getDashboardPartnerRequestSaga({ payload }) {
  const { companyUuid, partnerUuid } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getDataDashboardCompanyPartner(companyUuid, partnerUuid),
      data: payload,
    });

    return yield all([put(getDashboardPartnerFulfilled(data))]);
  } catch (error) {
    return yield put(getDashboardPartnerRejected());
  }
}

function* getPartnerDataGraphRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getPartnerDataGraph(
        payload.companyUuid,
        payload.partnerUuid,
        payload.intervalTime,
        payload.start_date,
        payload.end_date
      ),
    });

    return yield put(getPartnerDataGraphFulfilled(data));
  } catch (error) {
    return yield put(getPartnerDataGraphRejected());
  }
}

function* getDataDashboardHistoryRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getDataDashboardCompanyPartner(
        payload.companyUuid,
        payload.partnerUuid,
        payload.intervalTime
      ),
    });

    return yield put(getDataDashboardHistoryFulfilled(data));
  } catch (error) {
    return yield put(getDataDashboardHistoryRejected());
  }
}

function* getPartnerEnvironmentsCostGraphRequestSaga({ payload }) {
  const { companyUuid, partnerUuid, intervalTime } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getPartnerEnvironmentsCostGraph(
        companyUuid,
        partnerUuid,
        intervalTime
      ),
    });
    return yield put(getPartnerEnvironmentsCostGraphFulfilled(data));
  } catch (error) {
    return yield put(getPartnerEnvironmentsCostGraphRejected());
  }
}

export default all([
  takeLatest(getDashboardRequest, getDashboardRequestSaga),
  takeLatest(getDashboardPartnerRequest, getDashboardPartnerRequestSaga),
  takeLatest(getPartnerDataGraphRequest, getPartnerDataGraphRequestSaga),
  takeLatest(
    getDataDashboardHistoryRequest,
    getDataDashboardHistoryRequestSaga
  ),
  takeLatest(
    getPartnerEnvironmentsCostGraphRequest,
    getPartnerEnvironmentsCostGraphRequestSaga
  ),
]);
